// THIS WAS NECESSARY BECAUSE ALIASING LODASH WAS CAUSING A CONFLICT WITH ANTD'S LODASH

/**
 * Debounce utility function
 * @param {Function} func - The function to debounce
 * @param {number} wait - The number of milliseconds to delay
 * @returns {Function} The debounced function
 */
export const debounce = (func, wait) => {
    let timeout
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout)
            func(...args)
        }
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
    }
}
